import { createFileRoute, useRouter } from "@tanstack/react-router";
import { z } from "zod";

import { AppointmentTypeTextFieldForm } from "@/components/appointment/type/appointment-type-text-field-form";

import type { JSX } from "react";

const AppointmentTypeSecretariesInformationPage = (): JSX.Element => {
  const router = useRouter();
  const params = Route.useParams();

  return (
    <AppointmentTypeTextFieldForm
      appointmentTypeId={params.appointmentTypeId}
      field="description"
      onSaved={() => router.history.back()}
    />
  );
};

export const Route = createFileRoute(
  "/settings/schedule-options/appointment-types/$appointmentTypeId/secretary-info",
)({
  parseParams: (params) => ({
    appointmentTypeId: z.int().parse(Number(params.appointmentTypeId)),
  }),
  component: AppointmentTypeSecretariesInformationPage,
});
